import { Components, Theme } from '@mui/material'
import { colors } from '../constants'

const MuiListItemButton: Components<Theme>['MuiListItemButton'] = {
  styleOverrides: {
    root: {
      fontFamily: 'Montserrat Regular, Verdana, sans-serif',
      fontWeight: 400,
      letterSpacing: '0rem',
      lineHeight: '1.65',
      textTransform: 'initial',
      color: colors.grey[900],
      opacity: 0.8,
      padding: '15px 20px',
      '&:hover': {
        color: colors.teal[800],
        background: 'transparent',
      },
      '&:focus, &.Mui-selected:hover': {
        color: colors.teal[800],
        background: 'transparent',
        outline: '5px auto Highlight',
        // WebKit gets its native focus styles. Webkit will ignore the above line and
        // use this one, opposite for FireFox
        // Need to add a ts ignore here and below as typescript does not like the duplicate
        // identifier here.
        // @ts-expect-error no-duplicate-identifiers
        outline: '5px auto -webkit-focus-ring-color',
      },
      ':after': {
        width: '100%',
        height: '1px',
        backgroundColor: 'rgba(230, 230, 230, 1)',
        content: '""',
        display: 'block',
        position: 'absolute',
        bottom: '0',
        left: '0',
      },
    },
  },
}

export { MuiListItemButton }
